import { IKeyValue, resourceNameKeyValues } from "motw_core/Entity/IKeyValue";
import { resourceNameKeyValueLogs } from "motw_core/Entity/IKeyValueLog";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { LoadEmotionCharacterKVAsync } from "source/app/presentation/MainPanel/KeyValueLogs/KeyValueLogs";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { SetState } from "source/app/services/UI/State/SetState";
import { GetDefaultKeyValue } from "./defaultKeyValue";
import { State } from "source/app/services/UI/State/State";
import { IAppContainerState } from "source/app/presentation/AppContainer";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";

// KeyValue Update workflow is:
// Update local state ->
// Write to sql db ->
// Reload keyvalues from db into AppContainer ->
// For each loaded keyvalue, call setstate on its matching functional component
export async function UpdateKeyValueAsync(
    sharedStateKey: ESharedFunction,
    newValue: string
) {
    UpdateLocalKeyValueState(sharedStateKey, newValue);
    return await AddOrUpdateAsync(sharedStateKey, newValue);
}

function UpdateLocalKeyValueState(
    sharedStateKey: ESharedFunction,
    newValue: string
) {
    const newKeyValue = GetModifiedKeyValue(sharedStateKey, newValue);

    if (newKeyValue) {
        SetState<IKeyValue>(sharedStateKey, newKeyValue);
    }
}

function GetModifiedKeyValue(
    sharedStateKey: ESharedFunction,
    newValue: string
) {
    let newKeyValue = ReadState<IKeyValue>(sharedStateKey)!;

    if (!newKeyValue) {
        return;
    }

    newKeyValue.value = newValue;
    newKeyValue.lastmodifiedtime = new Date().toISOString();
    return newKeyValue;
}

async function AddOrUpdateAsync(
    sharedFunction: ESharedFunction,
    newValue: string
): Promise<void> {
    const key = ESharedFunction[sharedFunction];

    const existingKeyValueFromState = State.ReadClass<IAppContainerState>(
        ESharedComponent.AppContainer
    ).state.keyValues.find((keyValue) => keyValue.key === key);

    const keyValueResource = `${resourceNameKeyValues}?key=eq.${key}`;

    if (existingKeyValueFromState) {
        await UpdateExistingKeyValueAsync(keyValueResource, newValue);
    } else {
        const existingKeyValuesFromServer =
            await ClientDataProvider.GetRecordsAsync<IKeyValue>(
                keyValueResource
            );

        if (existingKeyValuesFromServer.length) {
            await UpdateExistingKeyValueAsync(keyValueResource, newValue);
        } else {
            const newKeyValue = {
                ...GetDefaultKeyValue(),
                key,
                value: newValue,
            };

            delete (newKeyValue as Partial<IKeyValue>).id;

            await ClientDataProvider.AddRecordAsync(
                resourceNameKeyValues,
                newKeyValue
            );
        }
    }

    await AddKeyValueLogRecordAsync(key, newValue);

    if (sharedFunction === ESharedFunction.EmotionSelector_character) {
        await LoadEmotionCharacterKVAsync();
    }
}

async function AddKeyValueLogRecordAsync(key: string, value: string) {
    await ClientDataProvider.AddRecordAsync(resourceNameKeyValueLogs, {
        key,
        value,
    });
}

async function UpdateExistingKeyValueAsync(resource: string, newValue: string) {
    await ClientDataProvider.UpdateRecordAsync(resource, {
        value: newValue,
    });
}
